import { GroupUserItemProps } from "apis";
import { lazy } from "react";

export const PageAdminGroupUser = lazy(() => import("./List"));
export const PageAdminGroupUserCreate = lazy(() => import("./Add"));
export const PageAdminGroupUserUpdate = lazy(() => import("./Edit"));
export const PageAdminGroupUserPermissionManager = lazy(() => import("./PermissionManager"));
export const PageAdminGroupUsers = lazy(() => import("./Users"));
export const PageAdminGroupFormAccessControll = lazy(() => import("./AccessControllForm"));



export interface FormGroupUserValuesProps extends GroupUserItemProps { }